import { Routes } from '@angular/router';
import { TitleResolver } from '../resolver/metatitles/metatitles.resolver';
import { ReportsViewComponent } from '../../pages/reports/reports-view/reports-view.component';
import { ReportsComponent } from '../../pages/reports/reports.component';
import { ReportsEvoViewComponent } from '../../pages/reports/reports-evo-view/reports-evo-view.component';
import { RoleAccountGuard } from '../../guards/role-account.guard';
import { ReportsEvoCampaignViewComponent } from '../../pages/reports/reports-evo-campaign-view/reports-evo-campaign-view.component';
import { ReportsEvoCampaignStockViewComponent } from '../../pages/reports/reports-evo-campaign-stock-view/reports-evo-campaign-stock-view.component';
import { ReportsNotDeliveredComponent } from '../../pages/reports/reports-not-delivered/reports-not-delivered.component';

export const reportsRoutes: Routes = [
  {
         path: 'reports',
         component: ReportsComponent,
         resolve: { title: TitleResolver },  canActivate: [RoleAccountGuard],
         data: { title: 'titles-menu-pages.reports', role: ['Admin', 'Supervisor'], account_type: ['broker', 'supplier'] },
       },
       {
        path: 'reports/not-delivered/tokens',
        component: ReportsNotDeliveredComponent,
        resolve: { title: TitleResolver },
        canActivate: [RoleAccountGuard],
        data: { title: 'titles-menu-pages.reports', role: ['Admin', 'Supervisor'], account_type: ['broker'] },
      },
        {
        path: 'reports/:subtype/campaign_stock',
        component: ReportsEvoCampaignStockViewComponent,
        resolve: { title: TitleResolver }, canActivate: [RoleAccountGuard],
        data: { title: 'titles-menu-pages.reports', type: 'contracts', role: ['Admin', 'Supervisor'], account_type: ['broker', 'supplier'] },
      },
      {
        path: 'reports/:subtype/evolution_campaign_stock',
        component: ReportsEvoCampaignStockViewComponent,
        resolve: { title: TitleResolver }, canActivate: [RoleAccountGuard],
        data: { title: 'titles-menu-pages.reports', type: 'contracts', role: ['Admin', 'Supervisor'], account_type: ['broker', 'supplier'] },
      },
        {
        path: 'reports/:subtype/campaign',
        component: ReportsEvoCampaignViewComponent,
        resolve: { title: TitleResolver }, canActivate: [RoleAccountGuard],
        data: { title: 'titles-menu-pages.reports', type: 'contracts', role: ['Admin', 'Supervisor'], account_type: ['broker', 'supplier'] },
      },
      {
        path: 'reports/:subtype/evolution',
        component: ReportsEvoViewComponent,
        resolve: { title: TitleResolver }, canActivate: [RoleAccountGuard],
        data: { title: 'titles-menu-pages.reports', type: 'contracts', role: ['Admin', 'Supervisor'], account_type: ['broker', 'supplier'] },
      },
       {
         path: 'reports/:subtype/:type',
         component: ReportsViewComponent,
         resolve: { title: TitleResolver },  canActivate: [RoleAccountGuard],
         data: { title: 'titles-menu-pages.reports', type: 'contracts', role: ['Admin', 'Supervisor'], account_type: ['broker', 'supplier'] },
       },
       
     
];

export function getFilteredReportsRoutes(accountType: string, role: string): Routes {
  return reportsRoutes.filter(route => {
    const allowedRoles = route.data?.['role'];
    const allowedAccountTypes = route.data?.['account_type'];
    const roleAllowed = !allowedRoles || allowedRoles.includes(role);
    const accountTypeAllowed = !allowedAccountTypes || allowedAccountTypes.includes(accountType);
    return roleAllowed && accountTypeAllowed;
  });
}
